/** * 检验报告列表 * */
<template>
  <div style="background: #f3f7fe">
    <div class="date-btn">
      <van-icon name="calender-o" />
      <span @click="showStartPicker = true">{{ getStartDate }}</span>
      至
      <span @click="showEndPicker = true">{{ getEndDate }}</span>
      <van-icon name="arrow-down" />
    </div>
    <ph-empty v-if="!inspectionList.length" />
    <div v-for="item in inspectionList" :key="item.year">
      <span class="list-item-year">
        {{ item.year }}
        <span>年</span>
      </span>
      <InspectionListMonthView
        v-for="subItem in item.list"
        :key="subItem.date"
        :date="subItem.date"
        :item-list="subItem.subItem"
        @routeToDetail="routeToDetail"
      />
    </div>
    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        v-model="startDate"
        @confirm="changeDate('start', $event)"
        @cancel="showStartPicker = false"
        type="date"
        title="选择开始日期"
      />
    </van-popup>
    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        v-model="endDate"
        @confirm="changeDate('end', $event)"
        @cancel="showEndPicker = false"
        type="date"
        title="选择结束日期"
      />
    </van-popup>
  </div>
</template>

<script>
import InspectionListMonthView from "./components/InspectionListMonthView";

export default {
  components: {
    InspectionListMonthView,
  },
  props: {
    image: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inspectionList: [],
      startDate: new Date(),
      endDate: new Date(),
      showStartPicker: false,
      showEndPicker: false,
      ftype: "1",
      qrtype: "1",
      patientId: "",
    };
  },
  computed: {
    getStartDate() {
      return this.startDate
        ? this.$moment(this.startDate).format("YYYY.MM.DD")
        : "";
    },
    getEndDate() {
      return this.endDate
        ? this.$moment(this.endDate).format("YYYY.MM.DD")
        : "";
    },
  },
  created() {
    this.ftype = this.$route.query.ftype || "1";
    this.qrtype = this.$route.query.qrtype || "1";
    this.startDate = this.$moment().add(-6, "month").toDate();
    this.endDate = this.$moment().toDate();
    this.getInspectionsList();
  },
  methods: {
    getInspectionsList() {
      this.$http
        .post(this.$api.USER_BASE_INFO, {
          functionType: this.ftype,
          eleFlag: this.qrtype === "2" ? "1" : "0",
        })
        .then((res) => {
          this.patientId = res.patientId;
        });
      const url = this.image
        ? this.$api.REPORT_IMAGE_LIST
        : this.$api.REPORT_INSPECTION_LIST;
      this.$http
        .post(this.$api.MEDICAL_IMAGING_LIST, {
          patientId: this.patientId,
          functionType: this.ftype,
          eleFlag: this.qrtype === "2" ? "1" : "0",
          startDate: this.$moment(this.startDate).format("YYYYMMDD"),
          endDate: this.$moment(this.endDate).format("YYYYMMDD"),
          reportType: "3",
        })
        .then((res) => {
          const list = [];
          var year = "";
          let subItemList = [];
          const keys = Object.keys(res);
          for (let i = 0; i < keys.length; i += 1) {
            const item = res[keys[i]];
            const itemYear = item.billingDate.substr(0, 4);
            if (i === 0) {
              year = itemYear;
            }
            const subList = item.list.map((inspectionItem) => {
              return {
                id: inspectionItem.sampleNo,
                title:
                  inspectionItem.reportProject || inspectionItem.projectName,
                inspectionType: inspectionItem.inspectionType,
              };
            });
            const subItem = {
              date: item.billingDate.substr(4),
              subItem: subList,
            };
            if (itemYear !== year) {
              list.push({
                year: year,
                list: subItemList,
              });
              subItemList = [subItem];
              year = itemYear;
            } else {
              subItemList.push(subItem);
            }
            if (i === keys.length - 1) {
              list.push({
                year: year,
                list: subItemList,
              });
            }
          }
          this.inspectionList = list;
        });
    },
    changeDate(type, e) {
      if (type === "start") {
        this.startDate = e;
        this.showStartPicker = false;
      } else {
        this.endDate = e;
        this.showEndPicker = false;
      }
      this.getInspectionsList();
    },
    routeToDetail(item, list, date) {
      this.$router.push({
        name: "medical-imaging-detail",
        query: {
          currentItem: item,
          list,
          date,
          ftype: this.ftype,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.list-item-year {
  margin-left: 0.5rem;
  color: #3f3f3f margin-left 1.5rem;
  font-size: 1.5rem;

  span {
    font-size: 1rem;
  }
}
.date-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.5rem;
  padding: 0.5rem;
  font-size: 0.94rem;
  border: solid 1px #aaa;
  border-radius: 4px;
}
</style>
